import { coreInitiativesGetAsyncSlice } from './get';
import { CoreInitiativesName } from './name';
import { postInitiative } from '@api';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesPostAsyncSlice = createPostAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.INITIATIVE_CREATED, (action) => ({
				craetedFrom: action.data.source
			})),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successActionCreators: [ coreInitiativesGetAsyncSlice.asyncActionCreators.repeatGetCoreInitiatives ]
	},
	name: CoreInitiativesName,
	receive: true,
	request: true,
	requestHandler: postInitiative,
	yieldType: SagaYieldType.Every
});
